import httpService from '@/api/httpService'

const DocumentsApi = (() => {
  const apiPostfix = 'documents'

  return {
    apiPostfix: apiPostfix,

    async getList () {
      const response = await httpService.get(`${apiPostfix}/journal`)
      return response.data
    },
    async deleteDocument (payload) {
      const response = await httpService.post(`${apiPostfix}/delete_document`, payload)
      return response.data
    },
    async openDocument (payload) {
      const response = await httpService.post(`${apiPostfix}/open_document`, payload)
      return response.data
    },
    async saveDocument (payload) {
      const response = await httpService.post(`${payload.name}/save_online`, payload)
      return response.data
    },
    async writeoutDocument (payload) {
      const response = await httpService.post(`rashodnayanakladnaya/writeout`, payload)
      return response.data
    },
    async excel (payload) {
      await httpService({
        url: `${apiPostfix}/xls`,
        method: 'GET',
        responseType: 'blob',
        params: payload
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('type', 'hidden')
        link.setAttribute('download', `${payload.name}_${payload.id}.xls`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    }

  }
})()

export default DocumentsApi
